<template>
  <div class="checkbox-line">
    <div class="top-item">
      <Checkbox
        :value="isSel"
        @click.prevent.native="handleCheckAll">
        <span class="line">{{line.name}}</span>
      </Checkbox>
    </div>
    <CheckboxGroup class="sub-items" v-model="allSel" @on-change="checkItem">
      <Checkbox v-for="item in line.children" :key="item.id" :label="item.id + ''">{{item.name}}</Checkbox>
    </CheckboxGroup>
  </div>
</template>
<script>
import { deepClone } from '@/utils/common'
export default {
  name: 'checkboxLine',
  data() {
    return {
      isSel: '',
      allSel: []
    }
  },
  props: {
    line: Object,
    index: Number
  },
  watch: {
    line: {
      handler: function() {
        this.init()
      },
      deep: true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const data = deepClone(this.line)
      this.isSel = data.isSel
      this.allSel = data.allSel
    },
    // 点全选的部分
    handleCheckAll() {
      this.isSel = !this.isSel
      if (this.line.children.length) {
        if (this.isSel) {
          this.allSel = this.line.children.map(item => {
            return item.id + ''
          })
        } else {
          this.allSel = []
        }
      }
      this.$emit('change', this.index, this.allSel, this.isSel)
    },
    // 点每个
    checkItem() {
      if (this.allSel.length && this.allSel.length === this.line.children.length) {
        this.isSel = true
      } else {
        this.isSel = false
      }
      this.$emit('change', this.index, this.allSel, this.isSel)
    }
  }
}
</script>
<style lang="scss">
  .checkbox-line {
    display: flex;
    border-bottom: 1px solid #D9E2EF;
    // height: 40px;
    // line-height: 40px;
    white-space: nowrap;
    position: relative;
  }
  .top-item,
  .sub-items {
    display: inline-block;
    white-space: pre-wrap;
    .ivu-checkbox-wrapper {
      height: 40px;
      line-height: 40px;
      width: 194px;
      .line {
        display: inline-block;
        height: 16px;
        line-height: 16px;
        width: 110px;
        vertical-align: text-bottom;
        border-right: 1px solid #D9E2EF;
      }
    }
  }
  .top-item {
    vertical-align: top;
  }
  .ivu-checkbox {
    position: relative;
    top: -2px;
  }
  .top-item {
    .ivu-checkbox {
      top: -3px
    }
  }
</style>
